var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value.name)?_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.customerHeader,"item-key":"id","items":_vm.customers,"hide-default-footer":"","disable-filtering":"","disable-pagination":"","disable-sort":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }